export default __webpack_public_path__ + "static/media/Overstock.1e831ee4.PNG";